import { render, staticRenderFns } from "./Country.vue?vue&type=template&id=561086d4&scoped=true&"
import script from "./Country.vue?vue&type=script&lang=ts&"
export * from "./Country.vue?vue&type=script&lang=ts&"
import style0 from "./Country.vue?vue&type=style&index=0&id=561086d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561086d4",
  null
  
)

export default component.exports